var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.error.statusCode)+"\n  ")]),_c('h2',{staticClass:"info"},[_vm._v("\n    "+_vm._s(_vm.error.message)+"\n  ")]),(_vm.error.statusCode === 404)?_c('nuxt-link',{staticClass:"button",attrs:{"to":"/"}},[_vm._v("\n    Homepage\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a3f5ea0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/smsgz/layouts/error.vue
// module id = P8Mc
// module chunks = 3